export default __webpack_public_path__ + "static/media/Ameen.8d66496e.jpg";